import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { DeserializedObject } from '@/src/lib/http/jsonapi/deserializer';
import { NavigationNode, NavigationRestAttributes } from '@/src/lib/navigation/type';
import { Dictionary } from '@/src/lib/dictionary/types';
import OffCanvasNavigationListItem from '@/src/app/components/OffCanvasNavigation/OffCanvasNavigationListItem/OffCanvasNavigationListItem';
export type OffCanvasNavigationListProps = {
  navigation: DeserializedObject<NavigationRestAttributes>;
  onCloseClick: () => void;
  dict: Dictionary;
  listType?: 'primary' | 'secondary' | 'tertiary';
  lang: string;
  targetNavigationNode?: NavigationNode;
  className?: string;
  languageDropdown?: React.JSX.Element;
};
function OffCanvasNavigationList(t0) {
  const $ = _c(21);
  const {
    navigation,
    onCloseClick,
    dict,
    listType: t1,
    lang,
    targetNavigationNode,
    className,
    languageDropdown
  } = t0;
  const listType = t1 === undefined ? "primary" : t1;
  const t2 = `menulabel-${navigation.id}`;
  let t3;
  if ($[0] !== dict || $[1] !== lang || $[2] !== languageDropdown || $[3] !== listType || $[4] !== navigation.nodes || $[5] !== onCloseClick || $[6] !== targetNavigationNode) {
    let t4;
    if ($[8] !== dict || $[9] !== lang || $[10] !== languageDropdown || $[11] !== listType || $[12] !== onCloseClick || $[13] !== targetNavigationNode) {
      t4 = (navigationItem, index) => <OffCanvasNavigationListItem navigationItem={navigationItem} key={navigationItem.resourceId ?? navigationItem.url ?? navigationItem.title} dict={dict} onCloseClick={onCloseClick} listType={listType} lang={lang} className={index === 0 ? "group is-first" : undefined} targetNavigationItem={targetNavigationNode} languageDropdown={languageDropdown} />;
      $[8] = dict;
      $[9] = lang;
      $[10] = languageDropdown;
      $[11] = listType;
      $[12] = onCloseClick;
      $[13] = targetNavigationNode;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    t3 = navigation.nodes.map(t4);
    $[0] = dict;
    $[1] = lang;
    $[2] = languageDropdown;
    $[3] = listType;
    $[4] = navigation.nodes;
    $[5] = onCloseClick;
    $[6] = targetNavigationNode;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[15] !== t3) {
    t4 = <ul>{t3}</ul>;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== className || $[18] !== t2 || $[19] !== t4) {
    t5 = <nav aria-labelledby={t2} className={className}>{t4}</nav>;
    $[17] = className;
    $[18] = t2;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
}
export default OffCanvasNavigationList;